import { queryClient } from 'App';
import debounce from 'lodash/debounce';

import { COMMUNICATION_LOGS_QUERY_KEY } from 'lib/constants/queries/queryKeys';
import { invalidateAllAppointments } from 'lib/queries/appointmentInvalidation';

// Sockets currently broadcast `appointment-create` without per-patient context,
// so the handler invalidates every cached appointment query. The semantic
// redesign (surgical patient/range invalidation gated on a backend-confirmed
// payload shape) is deferred per the migration plan, step 6 socket section.
export default debounce(() => {
  invalidateAllAppointments(queryClient);
  queryClient.invalidateQueries({ queryKey: [COMMUNICATION_LOGS_QUERY_KEY], exact: false });
}, 300);
